<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import ProfileInfo from 'src/components/cabinet/profile/components/info/Info.svelte'
    import ProfileDevices from 'src/components/cabinet/profile/components/devices/Devices.svelte'
    import ProfileTransactions from 'src/components/cabinet/profile/components/transactions/Transactions.svelte'
    import ProfileOldTransactions from 'src/components/cabinet/profile/components/old-transactions/Transactions.svelte'
    import ProfileOldGameTransactions from 'src/components/cabinet/profile/components/old-game-transactions/Transactions.svelte'
    import ProfileRefunds from 'src/components/cabinet/profile/components/refunds/Refunds.svelte'
    import ProfileGamePurchases from 'src/components/cabinet/profile/components/game-purchases/GamePurchases.svelte'
    import ProfileWithdrawals from 'src/components/cabinet/profile/components/withdrawals/Withdrawals.svelte'
    import ProfileDeposits from 'src/components/cabinet/profile/components/deposits/Deposits.svelte'
    import ProfileMemberships from 'src/components/cabinet/profile/components/memberships/Memberships.svelte'
    import ProfileReferrals from 'src/components/cabinet/profile/components/referrals/Referrals.svelte'
    import ProfileActions from 'src/components/cabinet/profile/components/actions/Actions.svelte'

    export let userId

    let tabs = [
        'info',
        'transactions',
        'withdrawals',
        'memberships',
        'referrals',
        'actions',
        'old-transactions',
        'old-game-transactions',
        'refunds',
        'game-purchases',
        'devices',
        'deposits',
    ]
    let selected = tabs[0]
</script>

<svelte:head>
    <title>Profile</title>
</svelte:head>

<MainLayout title="Profile">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <ul class="nav nav-tabs nav-bordered mb-3">
                    <li class="nav-item">
                        <div class="nav-link {selected === 'info' ? 'active':''}" on:click={()=>selected = tabs[0]}>
                            <span>Information</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'devices' ? 'active':''}" on:click={()=>selected = tabs[10]}>
                            <span>Devices</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'transactions' ? 'active':''}" on:click={()=>selected = tabs[1]}>
                            <span>Transactions</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'old-transactions' ? 'active':''}" on:click={()=>selected = tabs[6]}>
                            <span>Old transactions</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'old-game-transactions' ? 'active':''}" on:click={()=>selected = tabs[7]}>
                            <span>Old game transactions</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'game-purchases' ? 'active':''}" on:click={()=>selected = tabs[9]}>
                            <span>Game purchases</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'refunds' ? 'active':''}" on:click={()=>selected = tabs[8]}>
                            <span>Refunds</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'withdrawals' ? 'active':''}" on:click={()=>selected = tabs[2]}>
                            <span>Withdrawals</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'deposits' ? 'active':''}" on:click={()=>selected = tabs[11]}>
                            <span>Deposits</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'memberships' ? 'active':''}" on:click={()=>selected = tabs[3]}>
                            <span>Memberships</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'referrals' ? 'active':''}" on:click={()=>selected = tabs[4]}>
                            <span>Referrals</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link {selected === 'actions' ? 'active':''}" on:click={()=>selected = tabs[5]}>
                            <span>Actions</span>
                        </div>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active">
                        {#if selected === "info"}
                            <ProfileInfo {userId}/>
                        {:else if selected === "devices"}
                            <ProfileDevices {userId}/>
                        {:else if selected === "transactions"}
                            <ProfileTransactions userId={userId}/>
                        {:else if selected === "old-transactions"}
                            <ProfileOldTransactions {userId}/>
                        {:else if selected === "old-game-transactions"}
                            <ProfileOldGameTransactions {userId}/>
                        {:else if selected === "refunds"}
                            <ProfileRefunds {userId}/>
                        {:else if selected === "game-purchases"}
                            <ProfileGamePurchases {userId}/>
                        {:else if selected === "withdrawals"}
                            <ProfileWithdrawals {userId}/>
                        {:else if selected === "deposits"}
                            <ProfileDeposits {userId}/>
                        {:else if selected === "memberships"}
                            <ProfileMemberships {userId}/>
                        {:else if selected === "referrals"}
                            <ProfileReferrals {userId}/>
                        {:else if selected === "actions"}
                            <ProfileActions {userId}/>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .nav-tabs .nav-link {
        user-select: none;
        cursor: pointer;
    }

    .nav-tabs .nav-link.active {
        color: white;
        background-color: #FF5D1C;
        border-color: transparent transparent #FF5D1C;
        cursor: default;
    }
</style>
